import { Link } from "react-router-dom";
import { ArrowRight, Cog } from "lucide-react";
import Reveal from "../components/Reveal";

const ITEMS = ["Hosting", "Maintenance", "Security", "Backups", "Minor content changes", "Analytics reporting"];

export default function WebsiteCare() {
  return (
    <section data-testid="website-care-section" className="bg-[#F5F7FB] pb-24 sm:pb-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col gap-10 rounded-3xl border border-navyline bg-navy p-9 sm:p-12 lg:flex-row lg:items-center lg:gap-14">
            <div className="flex items-center gap-6 lg:min-w-[340px] lg:border-r lg:border-navyline lg:pr-14">
              <Cog className="h-11 w-11 shrink-0 text-gold" strokeWidth={1.4} />
              <div>
                <h3 className="font-display text-xl font-extrabold tracking-[0.1em] text-white">WEBSITE CARE</h3>
                <p data-testid="website-care-price" className="mt-1 font-display text-2xl font-extrabold text-gold">
                  $250<span className="text-base font-semibold text-slate-400">/month</span>
                </p>
              </div>
            </div>
            <div className="flex-1">
              <p className="text-sm leading-relaxed text-slate-400">
                After launch, AT Digital can keep your website fast, secure, and up to date — so you never have to
                manage the technical side yourself.
              </p>
              <ul className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3">
                {ITEMS.map((item) => (
                  <li key={item} className="flex items-center gap-2.5 text-[13px] font-medium text-slate-300">
                    <span className="h-1 w-1 rotate-45 bg-gold" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <Link
              to="/contact"
              data-testid="website-care-cta"
              className="group inline-flex w-fit shrink-0 items-center gap-2 rounded-full border border-gold/60 px-7 py-3.5 text-sm font-semibold text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
            >
              Ask About Website Care
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
